
        import * as module0 from './fields--button-toggle_controller.js';import * as module1 from './radar_chart_controller.js';import * as module2 from './scatter_chart_controller.js';import * as module3 from './walkthrough_controller.js'
        export default [module0.default,module1.default,module2.default,module3.default];
        export const context = {
          'fields--button-toggle_controller.js': module0.default,'radar_chart_controller.js': module1.default,'scatter_chart_controller.js': module2.default,'walkthrough_controller.js': module3.default
        }
      